<template>
	<div class="row flex-row">
		<div v-for="item in items" :key="item.ID" class="columns column4">
			<div class="promotion">
				<nuxt-link :to="localePath(`/${item.filename}`)">
					<picture>
						<source :srcset="item.overviewImageWebp" type="image/webp" />
						<source :srcset="item.overviewImage" />
						<img :src="item.overviewImage" :alt="item.overviewImageAlt" loading="lazy" />
					</picture>
				</nuxt-link>
				<div class="content">
					<h4>
						<nuxt-link :to="localePath(`/${item.filename}`)">
							{{ item.header }}
						</nuxt-link>
					</h4>
					<p>{{ item.overviewContent }}</p>
					<nuxt-link :to="localePath(`/${item.filename}`)" class="button">
						{{ $t('viewThisPackage') }}
					</nuxt-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
const localePath = useLocalePath();

defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.columns {
	display: flex;
}

.promotion {
	background-color: var(--primary-background-color);
	display: flex;
	flex-flow: column;
	margin: 0 auto 20px;
	position: relative;
	box-shadow: 0 0 10px rgb(0 0 0 / 5%);
	width: 100%;

	a {
		color: #fff;
		text-decoration: none;

		:deep(img) {
			width: 100%;
			opacity: 0.8;
			transition: all 0.3s ease-out;
		}

		:deep(img:hover) {
			opacity: 1;
		}
	}

	h4 {
		text-decoration: none;
		text-transform: uppercase;
		font-size: var(--h3-font-size);
		font-family: var(--heading-font-family);
		font-weight: 600;
		color: var(--primary-background-color);
	}

	.image {
		display: block;
		overflow: hidden;

		img {
			transition: all 0.3s ease-in-out;
		}
	}

	.content {
		flex: 1;
		padding: 30px 30px 90px;

		.button {
			position: absolute;
			bottom: 30px;
			left: 30px;
			color: #fff;
			padding: 5px 25px;
			font-size: 12px;
		}
	}
}

@media (max-width: 1060px) {
	.promotion {
		.content {
			padding: 30px 20px 90px;

			.button {
				left: 20px;
			}
		}
	}
}
</style>
